const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Background_Complete"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 382.398,
    style: {
      fill: "#EBEBEB"
    },
    width: 500,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.779,
    y: 398.494,
    style: {
      fill: "#EBEBEB"
    },
    width: 33.122,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.527,
    y: 401.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 8.693,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.586,
    y: 389.208,
    style: {
      fill: "#EBEBEB"
    },
    width: 19.192,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.459,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 43.193,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.556,
    y: 390.888,
    style: {
      fill: "#EBEBEB"
    },
    width: 6.333,
    height: 0.25
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.471,
    y: 395.111,
    style: {
      fill: "#EBEBEB"
    },
    width: 93.676,
    height: 0.25
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M237.014,337.8H43.915c-3.147,0-5.708-2.561-5.708-5.708V60.66c0-3.147,2.561-5.708,5.708-5.708 h193.099c3.146,0,5.707,2.561,5.707,5.708v271.432C242.721,335.239,240.16,337.8,237.014,337.8z M43.915,55.203 c-3.01,0-5.458,2.448-5.458,5.458v271.432c0,3.01,2.448,5.458,5.458,5.458h193.099c3.009,0,5.457-2.448,5.457-5.458V60.66 c0-3.009-2.448-5.458-5.457-5.458H43.915z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EBEBEB"
    },
    d: "M453.31,337.8H260.212c-3.147,0-5.707-2.561-5.707-5.708V60.66c0-3.147,2.561-5.708,5.707-5.708 H453.31c3.148,0,5.708,2.561,5.708,5.708v271.432C459.019,335.239,456.458,337.8,453.31,337.8z M260.212,55.203 c-3.009,0-5.457,2.448-5.457,5.458v271.432c0,3.01,2.448,5.458,5.457,5.458H453.31c3.01,0,5.458-2.448,5.458-5.458V60.66 c0-3.009-2.448-5.458-5.458-5.458H260.212z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 278.205,
    y: 161.206,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 706.6192 542.6393)",
    style: {
      fill: "#F0F0F0"
    },
    width: 150.209,
    height: 220.227
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 283.514,
    y: 168.138,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 706.6193 376.9503)",
    style: {
      fill: "#E0E0E0"
    },
    width: 139.59,
    height: 40.674
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.175,
    y: 174.723,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 838.28 383.5348)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 34.089
  }), /*#__PURE__*/React.createElement("rect", {
    x: 376.832,
    y: 174.723,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 761.5943 383.5348)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 34.089
  }), /*#__PURE__*/React.createElement("rect", {
    x: 330.351,
    y: 174.297,
    transform: "matrix(-0.9855 -0.1698 0.1698 -0.9855 631.2772 436.6844)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 34.089
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.35,
    y: 179.215,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 818.6288 388.0271)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 29.597
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.123,
    y: 179.215,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 782.1762 388.0271)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 29.597
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.118,
    y: 179.215,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 690.166 388.0271)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 29.597
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.113,
    y: 178.707,
    transform: "matrix(-0.9762 -0.2169 0.2169 -0.9762 683.4432 462.0263)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 29.597
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.493,
    y: 173.031,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 800.9504 381.8424)",
    style: {
      fill: "#EBEBEB"
    },
    width: 3.965,
    height: 35.781
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.327,
    y: 173.031,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 706.6192 381.8424)",
    style: {
      fill: "#EBEBEB"
    },
    width: 3.965,
    height: 35.781
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 283.514,
    y: 215.252,
    style: {
      fill: "#E0E0E0"
    },
    width: 139.59,
    height: 40.674
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.514,
    y: 221.837,
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 34.089
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.857,
    y: 221.837,
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 34.089
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.338,
    y: 221.411,
    transform: "matrix(0.9855 -0.1698 0.1698 0.9855 -35.089 66.6931)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 34.089
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293.34,
    y: 226.329,
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 29.597
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.566,
    y: 226.329,
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 29.597
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.571,
    y: 226.329,
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 29.597
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.577,
    y: 225.822,
    transform: "matrix(0.9762 -0.2169 0.2169 0.9762 -44.1063 79.3726)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 29.597
  }), /*#__PURE__*/React.createElement("rect", {
    x: 304.162,
    y: 220.144,
    style: {
      fill: "#EBEBEB"
    },
    width: 3.965,
    height: 35.781
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.327,
    y: 220.144,
    style: {
      fill: "#EBEBEB"
    },
    width: 3.965,
    height: 35.781
  }), /*#__PURE__*/React.createElement("rect", {
    x: 415.175,
    y: 221.837,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 838.28 477.7627)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 34.089
  }), /*#__PURE__*/React.createElement("rect", {
    x: 405.35,
    y: 226.329,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 818.6288 482.2549)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 29.597
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.123,
    y: 226.329,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 782.1762 482.2549)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 29.597
  }), /*#__PURE__*/React.createElement("rect", {
    x: 398.493,
    y: 220.144,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 800.9504 476.0702)",
    style: {
      fill: "#EBEBEB"
    },
    width: 3.965,
    height: 35.781
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 283.514,
    y: 262.366,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 706.6193 565.4062)",
    style: {
      fill: "#E0E0E0"
    },
    width: 139.59,
    height: 40.674
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 335.055,
    y: 268.951,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 678.0396 571.9908)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 34.089
  }), /*#__PURE__*/React.createElement("rect", {
    x: 288.574,
    y: 268.525,
    transform: "matrix(-0.9855 -0.1698 0.1698 -0.9855 532.3255 616.6757)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 34.089
  }), /*#__PURE__*/React.createElement("rect", {
    x: 363.572,
    y: 273.443,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 735.0741 576.483)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 29.597
  }), /*#__PURE__*/React.createElement("rect", {
    x: 345.346,
    y: 273.443,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 698.6214 576.483)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 29.597
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299.341,
    y: 273.443,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 606.6113 576.483)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 29.597
  }), /*#__PURE__*/React.createElement("rect", {
    x: 321.335,
    y: 272.935,
    transform: "matrix(-0.9762 -0.2169 0.2169 -0.9762 580.4435 639.1777)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 29.597
  }), /*#__PURE__*/React.createElement("rect", {
    x: 356.715,
    y: 267.258,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 717.3956 570.2983)",
    style: {
      fill: "#EBEBEB"
    },
    width: 3.965,
    height: 35.782
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.55,
    y: 267.258,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 623.0645 570.2983)",
    style: {
      fill: "#EBEBEB"
    },
    width: 3.965,
    height: 35.782
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.802,
    y: 268.525,
    transform: "matrix(-0.9855 -0.1698 0.1698 -0.9855 713.4562 632.1701)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 34.089
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.569,
    y: 273.443,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 789.0675 576.483)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 29.597
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.564,
    y: 272.935,
    transform: "matrix(-0.9762 -0.2169 0.2169 -0.9762 760.7278 658.9659)",
    style: {
      fill: "#EBEBEB"
    },
    width: 7.93,
    height: 29.597
  }), /*#__PURE__*/React.createElement("rect", {
    x: 400.778,
    y: 267.258,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 805.5207 570.2983)",
    style: {
      fill: "#EBEBEB"
    },
    width: 3.965,
    height: 35.782
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 428.414,
    y: 161.206,
    style: {
      fill: "#E0E0E0"
    },
    width: 25.914,
    height: 220.804
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 156.003,
    y: 106.458,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 299.9008 -43.111)",
    style: {
      fill: "#E0E0E0"
    },
    width: 31.005,
    height: 43.873
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.025,
    y: 108.522,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 299.9008 -43.111)",
    style: {
      fill: "#EBEBEB"
    },
    width: 26.962,
    height: 39.747
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 140.789,
    y: 145.408,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 323.6368 11.0534)",
    style: {
      fill: "#E0E0E0"
    },
    width: 31.005,
    height: 43.873
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.811,
    y: 147.472,
    transform: "matrix(-1.836970e-16 1 -1 -1.836970e-16 323.6368 11.0534)",
    style: {
      fill: "#EBEBEB"
    },
    width: 26.962,
    height: 39.747
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 113.33,
    y: 104.394,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 254.5772 248.2915)",
    style: {
      fill: "#E0E0E0"
    },
    width: 27.917,
    height: 39.503
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.15,
    y: 106.252,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 254.5772 248.2915)",
    style: {
      fill: "#EBEBEB"
    },
    width: 24.276,
    height: 35.788
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 97.448,
    y: 151.843,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 225.9018 347.5585)",
    style: {
      fill: "#E0E0E0"
    },
    width: 31.005,
    height: 43.873
  }), /*#__PURE__*/React.createElement("rect", {
    x: 99.47,
    y: 153.906,
    transform: "matrix(-1 -1.224647e-16 1.224647e-16 -1 225.9018 347.5585)",
    style: {
      fill: "#EBEBEB"
    },
    width: 26.962,
    height: 39.747
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 74.538,
    y: 114.583,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 -45.0831 218.4352)",
    style: {
      fill: "#E0E0E0"
    },
    width: 24.277,
    height: 34.352
  }), /*#__PURE__*/React.createElement("rect", {
    x: 76.121,
    y: 116.199,
    transform: "matrix(6.123234e-17 -1 1 6.123234e-17 -45.083 218.4353)",
    style: {
      fill: "#EBEBEB"
    },
    width: 21.111,
    height: 31.121
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Backgorund_Simple",
    style: {
      display: "none"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      display: "inline"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#766df4"
    },
    d: "M98.825,101.783c13.634-11.524,31.022-18.084,48.549-15.448 c22.51,3.385,38.554,20.309,48.111,40.014c9.746,20.096,10.292,45.728,28.071,61.307c15.037,13.177,37.792,13.484,56.876,7.52 c19.084-5.963,36.032-17.193,54.297-25.326c18.265-8.133,39.477-13.091,58.107-5.834c19.232,7.492,29.888,25.591,35.41,44.495 c5.396,18.469-0.053,40.22-6.432,57.977c-27.965,77.849-117.463,136.874-200.467,115.815 C141.147,361.956,83.02,276.131,71.431,197.241c-3.305-22.498-2.88-46.466,6.422-67.554 C82.547,119.045,89.878,109.345,98.825,101.783z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.9,
      fill: "#FFFFFF"
    },
    d: "M98.825,101.783c13.634-11.524,31.022-18.084,48.549-15.448 c22.51,3.385,38.554,20.309,48.111,40.014c9.746,20.096,10.292,45.728,28.071,61.307c15.037,13.177,37.792,13.484,56.876,7.52 c19.084-5.963,36.032-17.193,54.297-25.326c18.265-8.133,39.477-13.091,58.107-5.834c19.232,7.492,29.888,25.591,35.41,44.495 c5.396,18.469-0.053,40.22-6.432,57.977c-27.965,77.849-117.463,136.874-200.467,115.815 C141.147,361.956,83.02,276.131,71.431,197.241c-3.305-22.498-2.88-46.466,6.422-67.554 C82.547,119.045,89.878,109.345,98.825,101.783z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shadow_1_"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "_x3C_Path_x3E__359_",
    style: {
      fill: "#F5F5F5"
    },
    cx: 250,
    cy: 416.238,
    rx: 193.889,
    ry: 11.323
  })), /*#__PURE__*/React.createElement("g", {
    id: "Air_Conditioner"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#766df4"
    },
    d: "M435,69v39.32c0,2.21-1.79,3.68-4,3.68H298.21c0,0-15.35-7.16-14.26-17.16 c0.87-7.98,1.77-14.49,2.51-19.44c0.91-6.03,6.07-10.4,12.16-10.4H431C433.21,65,435,66.79,435,69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF"
    },
    d: "M435,69v39.32c0,2.21-1.79,3.68-4,3.68H298.21c0,0-15.35-7.16-14.26-17.16 c0.87-7.98,1.77-14.49,2.51-19.44c0.91-6.03,6.07-10.4,12.16-10.4H431C433.21,65,435,66.79,435,69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M435,69v39.32c0,2.21-1.79,3.68-4,3.68h-11.71 c0,0-15.36-7.16-14.26-17.16c0.87-7.98,1.77-14.49,2.51-19.44c0.9-6.03,6.07-10.4,12.16-10.4H431C433.21,65,435,66.79,435,69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#766df4"
    },
    d: "M287,98h116c0,0,3.833,8.5,10.333,12H300C300,110,288,104.5,287,98z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M287,98h116c0,0,3.833,8.5,10.333,12H300C300,110,288,104.5,287,98z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#766df4"
    },
    points: "295,106 407,106 405.333,110 295,110  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#766df4"
    },
    points: "291,101 403,101 401.333,105 291,105  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.167,
    y: 95,
    style: {
      fill: "#766df4"
    },
    width: 2.833,
    height: 1.167
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.164,
    y: 95,
    style: {
      fill: "#766df4"
    },
    width: 2.833,
    height: 1.167
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#766df4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M277.805,90.644 c-1.184-1.184-1.184-3.104,0-4.289"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#766df4",
      strokeWidth: 1.0566,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M276.229,92.22c-2.054-2.055-2.054-5.386,0-7.44"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#766df4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M274.766,93.684 c-2.863-2.863-2.863-7.505,0-10.367"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#766df4"
    },
    cx: 279.849,
    cy: 88.5,
    r: 0.854
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Table"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "50,315 50,417 57,417 57,330 174,330 174,417 183,417 183,315  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    points: "50,315 50,417 57,417 57,330 174,330 174,417 183,417 183,315  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.4,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "50,315 50,417 57,417 57,330 174,330 174,417  183,417 183,315  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "118,315 118,417 125,417 125,330 242,330 242,417 251,417 251,315  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "118,315 118,417 125,417 125,330 242,330 242,417  251,417 251,315  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M238.401,315h-38.58c-2.479,0-4.488-2.009-4.488-4.488v-61.333c0-2.478,2.009-4.488,4.488-4.488 h38.58c2.478,0,4.488,2.009,4.488,4.488v61.333C242.889,312.991,240.88,315,238.401,315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    d: "M238.401,315h-38.58c-2.479,0-4.488-2.009-4.488-4.488v-61.333 c0-2.478,2.009-4.488,4.488-4.488h38.58c2.478,0,4.488,2.009,4.488,4.488v61.333C242.889,312.991,240.88,315,238.401,315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    d: "M238.401,315h-12.247c-2.479,0-4.488-2.009-4.488-4.488v-61.333 c0-2.478,2.009-4.488,4.488-4.488h12.247c2.478,0,4.488,2.009,4.488,4.488v61.333C242.889,312.991,240.88,315,238.401,315z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M232.958,266.417c-3.929,0-7.125-3.197-7.125-7.126 c0-3.928,3.196-7.125,7.125-7.125c3.929,0,7.125,3.196,7.125,7.125C240.083,263.22,236.887,266.417,232.958,266.417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M239.188,259.292c0,3.441-2.789,6.23-6.23,6.23s-6.23-2.789-6.23-6.23 c0-3.441,2.789-6.23,6.23-6.23S239.188,255.851,239.188,259.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M235.464,259.292c0,1.72-1.395,3.115-3.115,3.115 c-1.72,0-3.115-1.395-3.115-3.115s1.395-3.115,3.115-3.115C234.069,256.177,235.464,257.571,235.464,259.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M234.901,259.292c0,1.41-1.143,2.552-2.552,2.552c-1.41,0-2.552-1.143-2.552-2.552 c0-1.409,1.143-2.552,2.552-2.552C233.758,256.739,234.901,257.882,234.901,259.292z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M232.958,288.417c-4.388,0-7.958-3.57-7.958-7.959 c0-4.388,3.57-7.958,7.958-7.958s7.958,3.57,7.958,7.958C240.917,284.847,237.347,288.417,232.958,288.417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M239.917,280.458c0,3.843-3.115,6.958-6.958,6.958c-3.843,0-6.958-3.115-6.958-6.958 c0-3.843,3.115-6.958,6.958-6.958C236.801,273.5,239.917,276.615,239.917,280.458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M235.757,280.458c0,1.921-1.558,3.479-3.479,3.479 c-1.921,0-3.479-1.558-3.479-3.479c0-1.922,1.558-3.479,3.479-3.479C234.199,276.979,235.757,278.537,235.757,280.458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M235.128,280.458c0,1.574-1.276,2.851-2.851,2.851s-2.851-1.276-2.851-2.851 c0-1.574,1.276-2.851,2.851-2.851S235.128,278.884,235.128,280.458z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 120.833,
    y: 290.118,
    style: {
      fill: "#263238"
    },
    width: 65.568,
    height: 24.882
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M188.421,292.818h-68.65c-0.978,0-1.771-0.793-1.771-1.771v-16.48 c0-0.978,0.793-1.771,1.771-1.771h68.65c0.978,0,1.771,0.793,1.771,1.771v16.48C190.191,292.026,189.399,292.818,188.421,292.818 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M188.421,292.818h-39.983 c-0.978,0-1.771-0.793-1.771-1.771v-16.48c0-0.978,0.793-1.771,1.771-1.771h39.983c0.978,0,1.771,0.793,1.771,1.771v16.48 C190.191,292.026,189.399,292.818,188.421,292.818z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M188.421,313.832h-68.65c-0.978,0-1.771-0.793-1.771-1.771v-16.48 c0-0.978,0.793-1.771,1.771-1.771h68.65c0.978,0,1.771,0.793,1.771,1.771v16.48C190.191,313.039,189.399,313.832,188.421,313.832 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M188.421,313.832h-39.983 c-0.978,0-1.771-0.793-1.771-1.771v-16.48c0-0.978,0.793-1.771,1.771-1.771h39.983c0.978,0,1.771,0.793,1.771,1.771v16.48 C190.191,313.039,189.399,313.832,188.421,313.832z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    d: "M188.421,292.818h-68.65c-0.978,0-1.771-0.793-1.771-1.771v-16.48 c0-0.978,0.793-1.771,1.771-1.771h68.65c0.978,0,1.771,0.793,1.771,1.771v16.48C190.191,292.026,189.399,292.818,188.421,292.818 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    d: "M188.421,313.832h-68.65c-0.978,0-1.771-0.793-1.771-1.771v-16.48 c0-0.978,0.793-1.771,1.771-1.771h68.65c0.978,0,1.771,0.793,1.771,1.771v16.48C190.191,313.039,189.399,313.832,188.421,313.832 z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 162.167,
    y: 280.005,
    style: {
      fill: "#766df4",
      enableBackground: "new"
    },
    width: 15.048,
    height: 7.15
  }), /*#__PURE__*/React.createElement("rect", {
    x: 160.833,
    y: 279.422,
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    width: 17.673,
    height: 8.27
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M160.917,304.088c0,2.531-2.052,4.583-4.583,4.583s-4.583-2.052-4.583-4.583 c0-2.531,2.052-4.583,4.583-4.583S160.917,301.557,160.917,304.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M162.918,304.088c0,2.531-2.052,4.583-4.583,4.583c-2.531,0-4.583-2.052-4.583-4.583 c0-2.531,2.052-4.583,4.583-4.583C160.866,299.505,162.918,301.557,162.918,304.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M162.918,304.088c0,2.531-2.052,4.583-4.583,4.583c-2.531,0-4.583-2.052-4.583-4.583 c0-2.531,2.052-4.583,4.583-4.583C160.866,299.505,162.918,301.557,162.918,304.088z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M186.933,304.088c0,2.531-2.052,4.583-4.583,4.583s-4.583-2.052-4.583-4.583 c0-2.531,2.052-4.583,4.583-4.583S186.933,301.557,186.933,304.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M188.934,304.088c0,2.531-2.052,4.583-4.583,4.583s-4.583-2.052-4.583-4.583 c0-2.531,2.052-4.583,4.583-4.583S188.934,301.557,188.934,304.088z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M188.934,304.088c0,2.531-2.052,4.583-4.583,4.583s-4.583-2.052-4.583-4.583 c0-2.531,2.052-4.583,4.583-4.583S188.934,301.557,188.934,304.088z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 164.583,
    y: 303.172,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 2.042,
    height: 2.042
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.408,
    y: 303.172,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 2.042,
    height: 2.042
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170.233,
    y: 303.172,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 2.042,
    height: 2.042
  }), /*#__PURE__*/React.createElement("rect", {
    x: 173.058,
    y: 303.172,
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    width: 2.042,
    height: 2.042
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M106.401,315h-38.58c-2.479,0-4.488-2.009-4.488-4.488v-61.333c0-2.478,2.009-4.488,4.488-4.488 h38.58c2.478,0,4.488,2.009,4.488,4.488v61.333C110.889,312.991,108.88,315,106.401,315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    d: "M106.401,315h-38.58c-2.479,0-4.488-2.009-4.488-4.488v-61.333 c0-2.478,2.009-4.488,4.488-4.488h38.58c2.478,0,4.488,2.009,4.488,4.488v61.333C110.889,312.991,108.88,315,106.401,315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF"
    },
    d: "M106.401,315H94.154c-2.479,0-4.488-2.009-4.488-4.488v-61.333 c0-2.478,2.009-4.488,4.488-4.488h12.247c2.478,0,4.488,2.009,4.488,4.488v61.333C110.889,312.991,108.88,315,106.401,315z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M100.959,266.417c-3.929,0-7.125-3.197-7.125-7.126 c0-3.928,3.196-7.125,7.125-7.125c3.929,0,7.125,3.196,7.125,7.125C108.083,263.22,104.887,266.417,100.959,266.417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M107.188,259.292c0,3.441-2.789,6.23-6.23,6.23c-3.441,0-6.23-2.789-6.23-6.23 c0-3.441,2.789-6.23,6.23-6.23C104.399,253.062,107.188,255.851,107.188,259.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M103.464,259.292c0,1.72-1.395,3.115-3.115,3.115 s-3.115-1.395-3.115-3.115s1.395-3.115,3.115-3.115S103.464,257.571,103.464,259.292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M102.901,259.292c0,1.41-1.143,2.552-2.552,2.552c-1.41,0-2.552-1.143-2.552-2.552 c0-1.409,1.143-2.552,2.552-2.552C101.758,256.739,102.901,257.882,102.901,259.292z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M100.959,288.417c-4.388,0-7.959-3.57-7.959-7.959 c0-4.388,3.57-7.958,7.959-7.958c4.388,0,7.958,3.57,7.958,7.958C108.916,284.847,105.347,288.417,100.959,288.417z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M107.917,280.458c0,3.843-3.115,6.958-6.958,6.958c-3.843,0-6.958-3.115-6.958-6.958 c0-3.843,3.115-6.958,6.958-6.958C104.801,273.5,107.917,276.615,107.917,280.458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M103.757,280.458c0,1.921-1.558,3.479-3.479,3.479 s-3.479-1.558-3.479-3.479c0-1.922,1.558-3.479,3.479-3.479S103.757,278.537,103.757,280.458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    d: "M103.128,280.458c0,1.574-1.276,2.851-2.851,2.851c-1.574,0-2.851-1.276-2.851-2.851 c0-1.574,1.276-2.851,2.851-2.851C101.852,277.608,103.128,278.884,103.128,280.458z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#766df4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M155.994,263.551 c1.184-1.184,3.105-1.184,4.289,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#766df4",
      strokeWidth: 1.0566,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M154.418,261.975c2.055-2.055,5.386-2.055,7.44,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#766df4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M152.955,260.511 c2.863-2.863,7.505-2.863,10.367,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#766df4"
    },
    d: "M158.992,265.595c0,0.472-0.382,0.854-0.854,0.854c-0.472,0-0.854-0.383-0.854-0.854 s0.382-0.854,0.854-0.854C158.61,264.741,158.992,265.123,158.992,265.595z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Sofa"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#766df4"
    },
    d: "M304.539,398.355h-60.236c-6.421,0-11.626-5.205-11.626-11.626v-47.358 c0-6.421,5.205-11.626,11.626-11.626h60.236c6.421,0,11.626,5.205,11.626,11.626v47.358 C316.165,393.15,310.96,398.355,304.539,398.355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M304.539,398.355h-60.236 c-6.421,0-11.626-5.205-11.626-11.626v-47.358c0-6.421,5.205-11.626,11.626-11.626h60.236c6.421,0,11.626,5.205,11.626,11.626 v47.358C316.165,393.15,310.96,398.355,304.539,398.355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M244.303,398.355L244.303,398.355 c-6.421,0-11.626-5.205-11.626-11.626v-47.358c0-6.421,5.205-11.626,11.626-11.626l0,0c6.421,0,11.626,5.205,11.626,11.626 v47.358C255.929,393.15,250.724,398.355,244.303,398.355z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "100,395.571 96.5,417 104,417 110.889,396.559  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "202.389,395.571 205.889,417 198.389,417 191.5,396.559  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "100,395.571 96.5,417 104,417 110.889,396.559  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    points: "202.389,395.571 205.889,417 198.389,417  191.5,396.559  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "309,395.571 305.5,417 313,417 319.889,396.559  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "411.389,395.571 414.889,417 407.389,417 400.5,396.559  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#766df4"
    },
    d: "M426,358.64c0-4.772-3.868-8.64-8.64-8.64H93.64c-4.772,0-8.64,3.868-8.64,8.64v33.72 c0,4.772,3.868,8.64,8.64,8.64h323.72c4.772,0,8.64-3.868,8.64-8.64V358.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M426,358.64c0-4.772-3.868-8.64-8.64-8.64H93.64 c-4.772,0-8.64,3.868-8.64,8.64v33.72c0,4.772,3.868,8.64,8.64,8.64h323.72c4.772,0,8.64-3.868,8.64-8.64V358.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M214,358.64c0-4.772-3.868-8.64-8.64-8.64H93.64 c-4.772,0-8.64,3.868-8.64,8.64v33.72c0,4.772,3.868,8.64,8.64,8.64h111.72c4.772,0,8.64-3.868,8.64-8.64V358.64z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#766df4"
    },
    d: "M297.956,351.185H420.94l18.741-96.786c2.049-10.581-6.056-20.406-16.833-20.406h-88.055 c-8.213,0-15.272,5.824-16.833,13.887L297.956,351.185z"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.1,
      enableBackground: "new"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M297.956,351.185H420.94l18.741-96.786c2.049-10.581-6.056-20.406-16.833-20.406h-88.055 c-8.213,0-15.272,5.824-16.833,13.887L297.956,351.185z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M297.951,351h88.06l20-103.21 c0.79-4.03,2.94-7.45,5.93-9.92c2.98-2.46,6.8-3.87,10.91-3.87h-88.06c-8.21,0-15.27,5.735-16.83,13.795L297.951,351z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#766df4"
    },
    d: "M434.621,398.355h-60.236c-6.421,0-11.626-5.205-11.626-11.626v-47.358 c0-6.421,5.205-11.626,11.626-11.626h60.236c6.421,0,11.626,5.205,11.626,11.626v47.358 C446.247,393.15,441.042,398.355,434.621,398.355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M434.621,398.355h-60.236 c-6.421,0-11.626-5.205-11.626-11.626v-47.358c0-6.421,5.205-11.626,11.626-11.626h60.236c6.421,0,11.626,5.205,11.626,11.626 v47.358C446.247,393.15,441.042,398.355,434.621,398.355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M374.385,398.355L374.385,398.355 c-6.421,0-11.626-5.205-11.626-11.626v-47.358c0-6.421,5.205-11.626,11.626-11.626l0,0c6.421,0,11.626,5.205,11.626,11.626 v47.358C386.011,393.15,380.806,398.355,374.385,398.355z"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Character"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_x3C_Group_x3E__1_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#766df4"
    },
    d: "M324.114,340.633c0,0-9.447,13.367-24.035,12.367c-27.271-1.87-60.412-40-64.412-40.333 c-6.327-0.527-59,27.967-59,27.967L167,329.827c0,0,56.651-44.709,69-45.434S324.114,340.633,324.114,340.633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M324.255,340.63c0,0-0.255,0.19-0.255,0.53v0.01 c-1,1.47-4.855,5.63-10.205,8.6c-3.72,2.08-8.382,3.59-13.642,3.23c-27.27-1.87-60.446-40-64.446-40.33 c-6.33-0.53-59.018,27.96-59.018,27.96l-9.679-10.8c0,0,21.955-17.33,41.516-30.59c11.85-8.03,22.818-14.57,27.478-14.85 c11.46-0.67,77.581,48.32,87.051,55.39C323.794,340.33,324.255,340.63,324.255,340.63z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEC1BB"
    },
    d: "M308.919,236.35c0,0-5.357-0.096-5.543,0.848c-0.186,0.944,0.164,8.779,0.877,9.882 c0.713,1.102,2.666,2.691,2.666,2.691l-3.941,11.673l6.608,3.348l2.904-12.726c0,0,3.283-3.206,2.321-7.273 C313.85,240.725,308.919,236.35,308.919,236.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M308.919,236.35c0,0-5.357-0.096-5.543,0.848 c-0.186,0.944,0.164,8.779,0.877,9.882c0.713,1.102,2.666,2.691,2.666,2.691l-3.941,11.673l6.608,3.348l2.904-12.726 c0,0,3.283-3.206,2.321-7.273C313.85,240.725,308.919,236.35,308.919,236.35z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "302,261.594 303.625,258.155 311.712,261.594 311.178,265.75  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M331.5,251.5c-8,0.167-21.667,32.167-21.667,32.167s3.083-15.667,2.375-17.5 c-0.708-1.833-7.541-6.333-11.208-5.333s-11.5,26.756-6,35.794c5.5,9.039,15.667,11.206,29.833,1.706 C339,288.833,331.5,251.5,331.5,251.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M325.99,297.45c-0.37,0.31-0.76,0.575-1.16,0.845 c-8.12,5.44-14.92,6.705-20.29,5.705h-0.01c-3.99-1-7.19-3.555-9.53-7.405c-5.5-9.04,2.33-34.783,6-35.783 s10.5,3.509,11.21,5.349c0.69,1.79-2.24,16.814-2.37,17.484c0.42-0.97,13.78-31.978,21.66-32.148 C331.5,251.498,338.58,286.73,325.99,297.45z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M325.99,297.45c-0.37,0.31-0.76,0.61-1.16,0.88 c-8.12,5.44-14.92,7.06-20.29,5.74c11.29-5.42,19.75-19.68,19.75-19.68L325.99,297.45z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M344.722,250.667c0,0,3.923-7.181,19.101-4.341c15.177,2.841,12.239,8.793,7.354,10.895 c-4.885,2.102-22.413,0-22.413,0S343.744,253.329,344.722,250.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M344.722,250.667c0,0,3.923-7.181,19.101-4.341 c15.177,2.841,12.239,8.793,7.354,10.895c-4.885,2.102-22.413,0-22.413,0S343.744,253.329,344.722,250.667z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M302,318.621c0,0,15.25-10.364,20-25.992c4.75-15.629,9.5-41.129,9.5-41.129s22.75-5.75,44.75,2.5 s-2.678,80.205-22.913,87.812L302,318.621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEC1BB"
    },
    d: "M366.582,231.612c-1.992,6.01-4.629,17.151-0.84,21.814c0,0-5.644,5.18-14.79,4.229 c-7.929-0.824-4.375-6.656-4.375-6.656c7.088-0.771,7.556-5.899,6.966-10.841L366.582,231.612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M361.268,235.098l-7.715,5.061c0.152,1.152,0.206,2.315,0.16,3.476 c2.674-0.044,6.644-2.474,7.273-5.186C361.286,237.359,361.382,236.223,361.268,235.098z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M354,213.414c3.067,2.821,0.93,6.513-7.698,11.503c-2.527-4.531-1.875-12.499,0.911-14.112 C349.999,209.191,351.325,210.969,354,213.414z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEC1BB"
    },
    d: "M367.72,221.95c-1.18,6.09-1.78,10.37-3.91,13.69c-0.77,1.19-1.73,2.26-2.99,3.25 c-7.19,5.61-16.99,0.43-17.89-8.16c-0.03-0.27-0.05-0.55-0.06-0.83c-0.54-7.75,2.32-19.23,10.63-21.39 c6.14-1.63,12.44,2.02,14.07,8.16C368.03,218.39,368.08,220.2,367.72,221.95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M363.81,235.64c-0.77,1.19-1.73,2.26-2.99,3.25 c-7.19,5.61-16.99,0.43-17.89-8.16c-0.03-0.27-0.05-0.55-0.06-0.83c1.56,0.87,3.74,1.85,5.38,1.71 c2.87-0.23,5.945-2.202,7.93-2.83c1.676-0.53,3.75-0.1,3.75-0.1s3.19-1.97,4.01-4.95l0.8,1.74 C364.74,225.47,365.59,230.76,363.81,235.64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M354.958,222.601c-0.089,0.679-0.525,1.183-0.968,1.122c-0.443-0.061-0.726-0.65-0.636-1.329 c0.09-0.679,0.515-1.182,0.957-1.131C354.754,221.314,354.999,221.926,354.958,222.601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M347.233,221.598c-0.09,0.679-0.525,1.183-0.968,1.122c-0.443-0.061-0.735-0.65-0.646-1.338 c0.089-0.689,0.525-1.182,0.968-1.122C347.03,220.32,347.323,220.919,347.233,221.598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D58745"
    },
    d: "M349.711,222.249c-1.083,1.971-2.433,3.783-4.011,5.385c1.08,1.283,3.171,1.031,3.171,1.031 L349.711,222.249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M357.387,220.443c0.087,0.023,0.179,0.015,0.261-0.022c0.194-0.109,0.264-0.353,0.159-0.549 c-0.612-1.145-1.745-1.92-3.034-2.074c-0.213-0.021-0.403,0.135-0.424,0.348c-0.001,0.009-0.002,0.019-0.002,0.028 c-0.006,0.219,0.158,0.405,0.376,0.426l0,0c1.014,0.138,1.899,0.757,2.377,1.662C357.166,220.361,357.27,220.426,357.387,220.443 z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M344.059,218.533c0.154,0.019,0.306-0.05,0.394-0.179c0.538-0.872,1.462-1.434,2.483-1.511 c0.223-0.001,0.402-0.181,0.405-0.404c-0.001-0.219-0.175-0.398-0.394-0.405c-1.296,0.078-2.474,0.778-3.163,1.879 c-0.122,0.182-0.073,0.43,0.109,0.552c0.002,0.001,0.003,0.002,0.005,0.003C343.947,218.499,344.001,218.521,344.059,218.533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M365.369,214.115c-4.078,0.825-4.152,5.095,0.661,13.816c4.507-2.574,8.068-9.742,6.501-12.552 C370.965,212.57,368.931,213.4,365.369,214.115z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEC1BB"
    },
    d: "M370.823,229.149c-0.847,1.947-2.432,3.479-4.406,4.259c-2.622,1.006-4.194-1.277-3.691-3.889 c0.457-2.355,2.377-5.717,5.112-5.603C370.573,224.03,371.851,226.757,370.823,229.149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#263238",
      strokeWidth: 0.5263,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M354.918,230.976c0,0-1.852,2.518-5.867,1.788"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M347.125,208.121c-0.156,0.941,0.125,2.462,5.208,3.212c5.083,0.75,9.75-1.417,11.333,0 c1.583,1.417,3.238,5.952,3.238,5.952l5.595-1.251c0,0,1.25-3.709-1.75-7.913c-3-4.204-19.744-0.954-21.039-3.288 C349.711,204.833,347.463,206.086,347.125,208.121z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EEC1BB"
    },
    points: "160.389,349.978 156.507,342.936 171.035,330.74 174.902,337.777  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "174.902,337.777 171.026,330.745 162.723,337.718  166.91,344.506  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#766df4"
    },
    points: "174.857,344.356 163.402,330.905 168.558,325.186 180.843,340.189  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    points: "174.857,344.356 163.402,330.905 168.558,325.186 180.843,340.189  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#766df4"
    },
    d: "M157,343.545c0,0,0-0.001,0-0.002c0-0.002-0.421,0.017-0.421,0.016 c0.05-0.129,0.795-2.171,0.454-3.223c-0.098-0.277-0.55-0.557-0.825-0.661c-0.297-0.144-0.772-0.097-0.983,0.156 c-0.318,0.389-0.422,1.193-0.318,1.975c-0.49-0.705-1.149-1.441-1.713-1.507c-0.242-0.024-0.496,0.075-0.645,0.267 c-0.286,0.26-0.402,0.661-0.289,1.03c0.24,0.482,0.647,0.856,1.149,1.049c0.64,0.316,1.311,0.559,2.004,0.73 c0.014,0.018,0.032,0.034,0.054,0.04c0.023-0.001,0.037-0.022,0.058-0.03c0.03-0.005,0.319,0.111,0.342,0.09 c0.006-0.006,0.703,0.105,0.706,0.098C156.574,343.574,157,343.546,157,343.545z M155.384,340.065 c0.065-0.089,0.188-0.173,0.439-0.076l0.084,0.037c0.134,0.069,0.234,0.19,0.275,0.336c0.21,0.626-0.325,1.786-0.693,2.453 c-0.029-0.051-0.059-0.104-0.093-0.164C155.117,341.793,155.063,340.506,155.384,340.065z M152.607,341.482 c-0.056-0.236,0.017-0.484,0.191-0.653c0.072-0.096,0.189-0.147,0.308-0.134c0.561,0.062,1.432,1.278,1.984,2.236 C153.686,342.515,152.773,341.986,152.607,341.482z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M156.566,342.757l7.988,4.184c0.285,0.133,0.408,0.473,0.275,0.758 c-0.001,0.003-0.003,0.006-0.004,0.008l-2.925,6.53c-0.361,0.689-1.209,0.959-1.902,0.607c-2.763-1.505-4.008-2.362-7.508-4.231 c-2.154-1.136-6.519-3.177-9.22-5.193c-2.701-2.016-0.635-4.632,0.686-4.016c3.141,1.446,8.34,1.645,11.171,1.121 C155.619,342.44,156.125,342.522,156.566,342.757z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M350.952,257.655c0,0,0.677-4.22,10.363-8.104c9.685-3.884,17.852,0.434,16.685,3.275 c0,0,6.287,0.65,3.06,4.829C377.833,261.833,350.952,257.655,350.952,257.655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M348.764,257.221c0,0-2.43-4.847,1.26-9.216c0,0-1.456-2.662-4.323,0 C345.7,248.004,334.194,250.942,348.764,257.221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M350.952,257.655c0,0,0.677-4.22,10.363-8.104 c9.685-3.884,17.852,0.434,16.685,3.275c0,0,6.287,0.65,3.06,4.829C377.833,261.833,350.952,257.655,350.952,257.655z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M348.764,257.221c0,0-2.43-4.847,1.26-9.216c0,0-1.456-2.662-4.323,0 C345.7,248.004,334.194,250.942,348.764,257.221z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M346.388,255.694 c0,0-5.638,2.102-6.138,15.954c-0.5,13.852-7.25,13.794-7.25,13.794"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#FFFFFF",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M353,256.625 c0,0-2.782,4.375-1.016,12.875c1.766,8.5,0.766,18.125-4.984,21.25"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M318.011,243.196c0.018,0.51-0.382,0.892-0.894,0.852l-9.112-0.707 c-0.512-0.04-0.942-0.486-0.961-0.996l-0.639-18.142c-0.018-0.51,0.392-1.016,0.904-0.976l9.112,0.707 c0.512,0.04,0.933,0.61,0.951,1.12L318.011,243.196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M316.371,224.858l0.652,18.318c0.019,0.517-0.275,0.844-0.784,0.804l-7.727-0.6 c-0.519-0.04-1.446-0.399-1.465-0.916l-0.647-18.38c-0.019-0.516,0.898-0.858,1.416-0.818l7.727,0.6 C316.052,223.905,316.352,224.341,316.371,224.858z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EEC1BB"
    },
    d: "M327.274,256.978l-3.466-8.077c0,0-1.126-10.844-1.675-12.005s-9.367-0.727-10.319-0.801 c-0.953-0.074-0.777,10.752,0.144,11.886c0.921,1.134,4.524,2.052,4.524,2.052l4.419,11.56L327.274,256.978z"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#263238"
    },
    points: "319.226,261.594 318.012,256.625 327.274,252.021 328.667,256.807  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M318.012,261.594c1.064-2.853,5.822-7.205,10.655-5.9C333.5,257,344.514,291.833,347.34,293.5 c2.826,1.667,22.394-28.333,27.777-30.5s9.505,0.135,9.694,12.484c0.189,12.349-19.9,46.468-37.105,43.659 C330.5,316.333,313.5,273.688,318.012,261.594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    d: "M318.012,261.594c1.064-2.853,5.822-7.205,10.655-5.9 C333.5,257,344.514,291.833,347.34,293.5c2.826,1.667,22.394-28.333,27.777-30.5s9.505,0.135,9.694,12.484 c0.189,12.349-19.9,46.468-37.105,43.659C330.5,316.333,313.5,273.688,318.012,261.594z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      enableBackground: "new"
    },
    d: "M319.405,350.04c-1.81,0.1-3.762,0.01-5.683-0.27 c-28.94-4.05-68.996-47.65-70.946-50c-1.38-1.67-21.178-1.1-34.238-0.53c11.85-8.03,22.811-14.57,27.471-14.85 c11.46-0.67,77.651,48.32,87.12,55.39c0.27,0.47-0.129,0.93,0.871,1.38v0.01C326,346.3,325.505,349.69,319.405,350.04z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#766df4"
    },
    d: "M362.362,334.771c0,0-10.862,22.82-44.862,17.729c-27.034-4.048-62.539-57.227-65.917-59.395 c-5.343-3.428-65.227-2.919-65.227-2.919l-3.481-14.075c0,0,70.992-12.974,82.243-7.831c6.171,2.821,63.132,51.97,63.132,51.97 L362.362,334.771z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M362.362,334.771c0,0-10.862,22.82-44.862,17.729 c-27.034-4.048-62.539-57.227-65.917-59.395c-5.343-3.428-65.227-2.919-65.227-2.919l-3.481-14.075 c0,0,70.992-12.974,82.243-7.831c6.171,2.821,63.132,51.97,63.132,51.97L362.362,334.771z"
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EEC1BB"
    },
    points: "167.597,290.82 167.465,282.78 186.013,278.807 186.134,286.837  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      enableBackground: "new"
    },
    points: "186.134,286.837 186.003,278.807 175.401,281.081  175.921,289.039  "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#766df4"
    },
    points: "183.014,292.629 179.191,275.379 186.425,272.74 190.254,291.75  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF"
    },
    points: "183.014,292.629 179.191,275.379 186.425,272.74 190.254,291.75  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#766df4"
    },
    d: "M168,283.524c0,0,0-0.001,0-0.002c0-0.002-0.572-0.169-0.571-0.17 c0.105-0.091,1.623-1.54,1.814-2.629c0.043-0.291-0.273-0.746-0.467-0.967c-0.195-0.266-0.661-0.445-0.966-0.321 c-0.463,0.194-0.943,0.857-1.218,1.598c-0.102-0.853-0.346-1.811-0.814-2.133c-0.203-0.135-0.476-0.166-0.698-0.066 c-0.374,0.096-0.667,0.395-0.739,0.775c-0.014,0.538,0.17,1.059,0.523,1.465c0.418,0.579,0.896,1.108,1.428,1.584 c0.004,0.023,0.012,0.045,0.029,0.061c0.021,0.01,0.043-0.002,0.065,0c0.029,0.009,0.23,0.247,0.26,0.24 c0.008-0.002,0.764,0.41,0.77,0.404L168,283.524z M167.817,279.717c0.099-0.048,0.247-0.065,0.424,0.138l0.057,0.072 c0.087,0.124,0.118,0.278,0.085,0.426c-0.107,0.652-1.123,1.426-1.761,1.842c-0.001-0.059-0.003-0.119-0.006-0.189 C166.772,281.12,167.327,279.957,167.817,279.717z M164.7,279.67c0.062-0.235,0.242-0.42,0.474-0.487 c0.109-0.051,0.236-0.042,0.335,0.026c0.466,0.318,0.667,1.8,0.705,2.905C165.17,281.087,164.61,280.192,164.7,279.67z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M167.601,282.649l5.098,7.438c0.189,0.251,0.139,0.609-0.112,0.798 c-0.003,0.002-0.005,0.004-0.007,0.005l-5.642,4.4c-0.641,0.44-1.517,0.282-1.964-0.354c-1.737-2.624-2.435-3.964-4.653-7.254 c-1.372-2.012-4.273-5.86-5.715-8.906c-1.442-3.046,1.608-4.39,2.486-3.227c2.098,2.749,6.598,5.359,9.345,6.222 C166.912,281.926,167.321,282.235,167.601,282.649z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#766df4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M310.064,218.429 c1.184-1.184,3.105-1.184,4.289,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#766df4",
      strokeWidth: 1.0566,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M308.488,216.853c2.055-2.055,5.386-2.055,7.44,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#766df4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "M307.024,215.39 c2.863-2.863,7.505-2.863,10.367,0"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#766df4"
    },
    d: "M313.062,220.473c0,0.472-0.382,0.854-0.854,0.854c-0.472,0-0.854-0.382-0.854-0.854 c0-0.472,0.382-0.854,0.854-0.854C312.68,219.619,313.062,220.001,313.062,220.473z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Bubble"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#766df4"
    },
    d: "M280.422,206.493H171.756c-3.415,0-6.184-2.768-6.184-6.184v-62.208 c0-3.415,2.769-6.184,6.184-6.184h108.666c3.415,0,6.184,2.769,6.184,6.184v62.208 C286.606,203.725,283.837,206.493,280.422,206.493z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#766df4"
    },
    d: "M280.153,205.48H172.025c-3.003,0-5.437-2.434-5.437-5.436v-61.676 c0-3.003,2.434-5.437,5.437-5.437h108.128c3.003,0,5.436,2.434,5.436,5.437v61.676 C285.589,203.046,283.155,205.48,280.153,205.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.6,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M280.153,205.48H172.025c-3.003,0-5.437-2.434-5.437-5.436 v-61.676c0-3.003,2.434-5.437,5.437-5.437h108.128c3.003,0,5.436,2.434,5.436,5.437v61.676 C285.589,203.046,283.155,205.48,280.153,205.48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2,
      fill: "#FFFFFF",
      enableBackground: "new"
    },
    d: "M280.153,201.477H172.025 c-3.003,0-5.437-2.434-5.437-5.437v-57.674c0-3.003,2.434-5.437,5.437-5.437h108.128c3.003,0,5.436,2.434,5.436,5.437v57.674 C285.589,199.044,283.155,201.477,280.153,201.477z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M268.027,150.355h-91.881c-0.92,0-1.666-0.746-1.666-1.666v-8.064 c0-0.92,0.746-1.666,1.666-1.666h91.881c0.92,0,1.666,0.746,1.666,1.666v8.064 C269.693,149.609,268.947,150.355,268.027,150.355z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 177.4223 148.3545)",
    style: {
      fill: "#766df4",
      fontFamily: "'Bebas'",
      fontSize: "8.0323px"
    }
  }, "Home Conditioners"), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M268.027,150.355h-91.881c-0.92,0-1.666-0.746-1.666-1.666v-8.064 c0-0.92,0.746-1.666,1.666-1.666h91.881c0.92,0,1.666,0.746,1.666,1.666v8.064 C269.693,149.609,268.947,150.355,268.027,150.355z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M268.027,164.719h-91.881c-0.92,0-1.666-0.746-1.666-1.666v-8.064 c0-0.92,0.746-1.666,1.666-1.666h91.881c0.92,0,1.666,0.746,1.666,1.666v8.064 C269.693,163.973,268.947,164.719,268.027,164.719z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 177.4223 162.719)",
    style: {
      fill: "#766df4",
      fontFamily: "'Bebas'",
      fontSize: "8.0323px"
    }
  }, "Air Conditioner"), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M268.027,164.719h-91.881c-0.92,0-1.666-0.746-1.666-1.666v-8.064 c0-0.92,0.746-1.666,1.666-1.666h91.881c0.92,0,1.666,0.746,1.666,1.666v8.064 C269.693,163.973,268.947,164.719,268.027,164.719z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M268.027,179.084h-91.881c-0.92,0-1.666-0.746-1.666-1.666v-8.064 c0-0.92,0.746-1.666,1.666-1.666h91.881c0.92,0,1.666,0.746,1.666,1.666v8.064 C269.693,178.338,268.947,179.084,268.027,179.084z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 177.4223 177.0836)",
    style: {
      fill: "#766df4",
      fontFamily: "'Bebas'",
      fontSize: "8.0323px"
    }
  }, "Air20"), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M268.027,179.084h-91.881c-0.92,0-1.666-0.746-1.666-1.666v-8.064 c0-0.92,0.746-1.666,1.666-1.666h91.881c0.92,0,1.666,0.746,1.666,1.666v8.064 C269.693,178.338,268.947,179.084,268.027,179.084z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M268.027,193.448h-91.881c-0.92,0-1.666-0.746-1.666-1.666v-8.064 c0-0.92,0.746-1.666,1.666-1.666h91.881c0.92,0,1.666,0.746,1.666,1.666v8.064 C269.693,192.702,268.947,193.448,268.027,193.448z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 177.4223 191.4481)",
    style: {
      fill: "#766df4",
      fontFamily: "'Bebas'",
      fontSize: "8.0323px"
    }
  }, "Cassette"), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.3,
      fill: "#FFFFFF"
    },
    d: "M268.027,193.448h-91.881c-0.92,0-1.666-0.746-1.666-1.666v-8.064 c0-0.92,0.746-1.666,1.666-1.666h91.881c0.92,0,1.666,0.746,1.666,1.666v8.064 C269.693,192.702,268.947,193.448,268.027,193.448z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M265.781,148.624h-14.509c-0.872,0-1.579-0.707-1.579-1.579v-4.777 c0-0.872,0.707-1.579,1.579-1.579h14.509c0.872,0,1.579,0.707,1.579,1.579v4.777 C267.36,147.917,266.653,148.624,265.781,148.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M255.775,148.624h-4.503c-0.872,0-1.579-0.707-1.579-1.579v-4.777 c0-0.872,0.707-1.579,1.579-1.579h4.503c0.872,0,1.579,0.707,1.579,1.579v4.777 C257.353,147.917,256.647,148.624,255.775,148.624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M265.781,148.624h-14.509c-0.872,0-1.579-0.707-1.579-1.579v-4.777 c0-0.872,0.707-1.579,1.579-1.579h14.509c0.872,0,1.579,0.707,1.579,1.579v4.777 C267.36,147.917,266.653,148.624,265.781,148.624z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M265.781,191.651h-14.509c-0.872,0-1.579-0.707-1.579-1.579v-4.777 c0-0.872,0.707-1.579,1.579-1.579h14.509c0.872,0,1.579,0.707,1.579,1.579v4.777 C267.36,190.944,266.653,191.651,265.781,191.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M255.775,191.651h-4.503c-0.872,0-1.579-0.707-1.579-1.579v-4.777 c0-0.872,0.707-1.579,1.579-1.579h4.503c0.872,0,1.579,0.707,1.579,1.579v4.777 C257.353,190.944,256.647,191.651,255.775,191.651z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M265.781,191.651h-14.509c-0.872,0-1.579-0.707-1.579-1.579v-4.777 c0-0.872,0.707-1.579,1.579-1.579h14.509c0.872,0,1.579,0.707,1.579,1.579v4.777 C267.36,190.944,266.653,191.651,265.781,191.651z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#766df4"
    },
    d: "M265.781,177.309h-14.509c-0.872,0-1.579-0.707-1.579-1.579v-4.777 c0-0.872,0.707-1.579,1.579-1.579h14.509c0.872,0,1.579,0.707,1.579,1.579v4.777 C267.36,176.602,266.653,177.309,265.781,177.309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M265.781,177.309h-4.503c-0.872,0-1.579-0.707-1.579-1.579v-4.777 c0-0.872,0.707-1.579,1.579-1.579h4.503c0.872,0,1.579,0.707,1.579,1.579v4.777 C267.36,176.602,266.653,177.309,265.781,177.309z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#766df4"
    },
    d: "M265.781,162.966h-14.509c-0.872,0-1.579-0.707-1.579-1.579v-4.777 c0-0.872,0.707-1.579,1.579-1.579h14.509c0.872,0,1.579,0.707,1.579,1.579v4.777 C267.36,162.26,266.653,162.966,265.781,162.966z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M265.781,162.966h-4.503c-0.872,0-1.579-0.707-1.579-1.579v-4.777 c0-0.872,0.707-1.579,1.579-1.579h4.503c0.872,0,1.579,0.707,1.579,1.579v4.777C267.36,162.26,266.653,162.966,265.781,162.966 z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M269.693,205.25v-7.523c0-0.92-0.746-1.666-1.666-1.666h-91.881 c-0.92,0-1.666,0.746-1.666,1.666v7.523H269.693z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#263238"
    },
    d: "M250.219,205.25h16.615c0.321-0.289,0.526-0.703,0.526-1.169v-4.777 c0-0.872-0.707-1.579-1.579-1.579h-14.509c-0.872,0-1.579,0.707-1.579,1.579v4.777 C249.693,204.547,249.899,204.961,250.219,205.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M250.219,205.25h6.608c0.321-0.289,0.526-0.703,0.526-1.169v-4.777 c0-0.872-0.707-1.579-1.579-1.579h-4.503c-0.872,0-1.579,0.707-1.579,1.579v4.777 C249.693,204.547,249.899,204.961,250.219,205.25z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.5,
      fill: "#FFFFFF"
    },
    d: "M250.219,205.25h16.615c0.321-0.289,0.526-0.703,0.526-1.169v-4.777 c0-0.872-0.707-1.579-1.579-1.579h-14.509c-0.872,0-1.579,0.707-1.579,1.579v4.777 C249.693,204.547,249.899,204.961,250.219,205.25z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.2
    },
    d: "M276.625,201.759L276.625,201.759c-1.174,0-2.125-0.951-2.125-2.125v-58.55 c0-1.174,0.951-2.125,2.125-2.125l0,0c1.174,0,2.125,0.951,2.125,2.125v58.55C278.75,200.808,277.799,201.759,276.625,201.759z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M276.625,161.734L276.625,161.734c-1.174,0-2.125-0.951-2.125-2.125v-18.525 c0-1.174,0.951-2.125,2.125-2.125l0,0c1.174,0,2.125,0.951,2.125,2.125v18.525C278.75,160.782,277.799,161.734,276.625,161.734z "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#766df4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    x1: 224.5,
    y1: 206,
    x2: 224.5,
    y2: 209
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#766df4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "5,2"
    },
    x1: 224.5,
    y1: 211,
    x2: 224.5,
    y2: 225
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#766df4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    points: "224.5,226 224.5,228.5  227,228.5  "
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#766df4",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeDasharray: "5,2"
    },
    x1: 229,
    y1: 228.5,
    x2: 298,
    y2: 228.5
  }), /*#__PURE__*/React.createElement("line", {
    style: {
      fill: "none",
      stroke: "#766df4",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    x1: 299,
    y1: 228.5,
    x2: 302,
    y2: 228.5
  }))), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#766df4"
    },
    cx: 303.483,
    cy: 228.5,
    r: 1.145
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.608e76f0d100dea9adc98f633ea51691.svg";
export { ForwardRef as ReactComponent };